import validate from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/node_modules/nuxt/dist/pages/runtime/validate.js";
import checkpoint_45global from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/middleware/checkpoint.global.ts";
import manifest_45route_45rule from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-connect-liff/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  checkpoint_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}